export default function Footer() {
  return (
    <footer className="mt-auto py-4 px-4 border-t border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-sm text-gray-600 dark:text-slate-400">
          Developed in Italy with ♥ by Marco, Massimiliano, Chiara and Roberto
        </p>
      </div>
    </footer>
  );
}
